/**
 * Instagram / Facebook Android in-app browser compatibility layer.
 * Fixes: view-transition freeze, Meta injected-script crashes, overlay tap blocking.
 */
(function () {
  var ua = navigator.userAgent || '';
  var ref = document.referrer || '';
  var isAndroid = /Android/i.test(ua);
  var isMetaInApp =
    /Instagram|FBAN|FBAV|FB_IAB|FB4A|Messenger|MetaIAB/i.test(ua) ||
    (/Android/i.test(ua) && /; wv\)/i.test(ua) && /instagram|facebook|fbav|fban/i.test(ref));

  if (!isMetaInApp) return;

  window.__mmInAppBrowser = true;
  document.documentElement.classList.add('mm-inapp-browser');
  if (isAndroid) document.documentElement.classList.add('mm-inapp-browser--android');

  function isMetaWebViewNoise(message) {
    if (!message) return false;
    var msg = String(message);
    return (
      /java object is gone/i.test(msg) ||
      /navigation_performance_logger/i.test(msg) ||
      /enableButtonsClickedMetaDataLogging/i.test(msg) ||
      /enableDidUserTypeOnKeyboardLogging/i.test(msg)
    );
  }

  window.addEventListener(
    'error',
    function (event) {
      if (isMetaWebViewNoise(event.message) || isMetaWebViewNoise(event.error && event.error.message)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return true;
      }
    },
    true
  );

  window.addEventListener('unhandledrejection', function (event) {
    var reason = event.reason;
    var message = reason && reason.message ? reason.message : reason;
    if (isMetaWebViewNoise(message)) event.preventDefault();
  });

  function skipViewTransition(event) {
    if (!event || !('viewTransition' in event)) return;
    var vt = event.viewTransition;
    if (vt && typeof vt.skipTransition === 'function') {
      try {
        vt.skipTransition();
      } catch (e) {}
    }
  }

  window.addEventListener('pageswap', skipViewTransition, true);
  window.addEventListener('pagereveal', skipViewTransition, true);

  function applyInAppStyles() {
    var style = document.createElement('style');
    style.id = 'mm-inapp-browser-styles';
    style.textContent =
      '@view-transition{navigation:none!important}' +
      'html.mm-inapp-browser,html.mm-inapp-browser body{overflow-x:hidden!important;overflow-y:auto!important;-webkit-overflow-scrolling:touch}' +
      'html.mm-inapp-browser ::view-transition,html.mm-inapp-browser ::view-transition-group,' +
      'html.mm-inapp-browser ::view-transition-old,html.mm-inapp-browser ::view-transition-new{display:none!important;pointer-events:none!important}' +
      'html.mm-inapp-browser *{view-transition-name:none!important}' +
      'html.mm-inapp-browser .scroll-trigger,html.mm-inapp-browser [class*="animate--"]{animation:none!important;opacity:1!important;transform:none!important}' +
      'html.mm-inapp-browser .mm-popup-overlay:not(.active),' +
      'html.mm-inapp-browser .mm-drawer-overlay:not(.is-open),' +
      'html.mm-inapp-browser .mm-mobile-search-overlay:not(.is-open),' +
      'html.mm-inapp-browser .mms-overlay:not(.open){pointer-events:none!important}' +
      'html.mm-inapp-browser button,html.mm-inapp-browser a,html.mm-inapp-browser [role="button"]' +
      '{touch-action:manipulation;-webkit-tap-highlight-color:transparent}';
    (document.head || document.documentElement).appendChild(style);
  }

  function removeViewTransitionMeta() {
    document.querySelectorAll('meta[name="view-transition"]').forEach(function (el) {
      el.parentNode && el.parentNode.removeChild(el);
    });
  }

  function removeRenderBlocker() {
    var el = document.getElementById('view-transition-render-blocker');
    if (el) el.parentNode && el.parentNode.removeChild(el);
  }

  function unlockBodyIfNoModal() {
    var hasOpenModal =
      document.querySelector(
        '.mm-popup-overlay.active,.mm-drawer-overlay.is-open,.mm-mobile-search-overlay.is-open,' +
          '.mms-overlay.open,.mm-cart-sheet.is-open,#mm-locale-popup:not([hidden])'
      ) !== null;
    if (!hasOpenModal) {
      document.body.style.overflow = '';
      document.body.classList.remove('mm-cart-sheet-open');
    }
  }

  function disableMainTransitions() {
    var main = document.getElementById('MainContent');
    if (!main) return;
    main.removeAttribute('data-page-transition-enabled');
    main.removeAttribute('data-product-transition');
  }

  applyInAppStyles();
  removeViewTransitionMeta();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      removeViewTransitionMeta();
      removeRenderBlocker();
      disableMainTransitions();
      unlockBodyIfNoModal();
    });
  } else {
    removeRenderBlocker();
    disableMainTransitions();
    unlockBodyIfNoModal();
  }

  document.addEventListener(
    'touchstart',
    function () {
      unlockBodyIfNoModal();
    },
    { passive: true, capture: true }
  );

  new MutationObserver(function () {
    removeViewTransitionMeta();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
